import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";

import styles from "./Ring.module.scss";

export type RingData = {
  value: number | string;
  name: string;
  color?: any;
  itemStyle?: any;
};

type RingProps = {
  data: RingData[];
  title?: string;
};

const RingChart: React.FC<RingProps> = ({ data, title }) => {
  const chartRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (chartRef.current) {
      const myChart = echarts.init(chartRef.current);

      const colorPallete = data.map(({ color }) => color);

      const option: echarts.EChartsOption = {
        title: {
          left: "center",
          top: "bottom",
          textStyle: {
            fontSize: 16,
            fontWeight: "bold",
          },
        },
        tooltip: {
          trigger: "item",
        },
        series: [
          {
            name: title,
            type: "pie",
            radius: ["50%", "70%"],
            avoidLabelOverlap: false,
            startAngle: 180,
            itemStyle: {
              borderWidth: 2,
            },
            color: colorPallete,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: false,
                fontSize: 40,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            hoverLayerThreshold: 10000,
            data: data?.map((item: RingData) => ({
              name: item.name,
              value:
                typeof item.value === "string"
                  ? parseFloat(item.value)
                  : item.value,
            })),
          },
        ],
      };

      myChart.setOption(option);

      return () => {
        myChart.dispose();
      };
    }
  }, [data, title]);

  return <div ref={chartRef} className={styles.container} />;
};

export default RingChart;
